import { Typography } from '@musinsa/mds';
import { GoToMusinsaPrivacyPolicyLink } from '../GoToMusinsaPrivacyPolicy';

export const PrivacyPolicyContent = () => (
  <div className="px-4 py-3 justify-start">
    <Typography size="13" weight="regular" colorScheme="black" lineHeight="none">
      (주)무신사는 아래와 목적으로 정보수집과 제공을 이용하고나 개인정보를 처리하는 데 동의를
      구하고자 오직에 따른 조치를 이용하기 위하여 다음과 같이 처리합니다. 아래의 내용을 잘 확인
      부탁드립니다.
    </Typography>

    <ul className="py-4">
      <li className="flex items-center">
        <Typography size="13" weight="regular" colorScheme="black">
          • 처리목적: (주)무신사
        </Typography>
      </li>
      <li className="flex items-center">
        <Typography size="13" weight="regular" colorScheme="black">
          • 수집 및 이용 목적: 큐레이터 정산을 위함
        </Typography>
      </li>

      <li className="flex items-center">
        <Typography size="13" weight="regular" colorScheme="black">
          • 수집 및 이용 항목: 정산정보(은행명, 예금주명, 계좌번호), 계좌사본
        </Typography>
      </li>
      <li className="flex items-center">
        <Typography size="13" weight="regular" colorScheme="black">
          • 보유 및 이용 기간: 소득세법 및 국세기본법에 의해 5년간 보관 후 파기
        </Typography>
      </li>
      <li className="flex items-center">
        <Typography size="13" weight="regular" colorScheme="black">
          • 관련 법규: 개인정보 보호법 제15조(개인정보의 수집 · 이용)
        </Typography>
      </li>
    </ul>

    <div>
      <Typography size="13" weight="regular" colorScheme="black">
        수집한 개인정보는 수집 및 이용 목적 외의 목적으로는 이용하지 않습니다. <br />
        자세한 내용은 <GoToMusinsaPrivacyPolicyLink>개인정보처리방침</GoToMusinsaPrivacyPolicyLink>
        을 확인 부탁드립니다.
      </Typography>
    </div>
  </div>
);
